import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
// import { format } from "date-fns";
import { Button, Labeled } from "@lifepay/rc-ui-toolkit";

// import Badge from "components/visual/Badge";
// import Labeled from "components/visual/Labeled";
// import Details from "components/visual/Details";

import styles from "./Company.m.scss";

function Company(props) {
  const { theme, client, workWithClient } = props;
  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.summary)}>
        <Labeled label={"Id"} theme={{ label: theme.label }}>
          {client.companyId}
        </Labeled>
        <Labeled label={"Краткое наименование"} theme={{ label: theme.label }}>
          {client.companyName || "-"}
        </Labeled>
        <Labeled label={"Полное наименование"} theme={{ label: theme.label }}>
          {client.companyFullName || "-"}
        </Labeled>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            workWithClient({ type: "COMPANY", id: client.companyId })
          }
        >
          {"Работать с клиентом"}
        </Button>
      </div>
    </div>
  );
}

Company.displayName = "Company";

Company.propTypes = {
  theme: PropTypes.object,
  client: PropTypes.object.isRequired,
  workWithClient: PropTypes.func.isRequired,
};

Company.defaultProps = {};

export default themr("@lifepay/Company", styles)(Company);



// WEBPACK FOOTER //
// ./src/components/client-search/Company/Company.js